import { Indicator } from '../../../Common/Charts/Indicator';
import { useHomelessChartsDataContext } from './hooks/useHomelessChartsDataContext';

export const HomelessIndicator = () => {
    const { chartData } = useHomelessChartsDataContext();

    return (
        <Indicator
            title={'Indice de Pessoas em Situação de Rua'}
            indicatorValue={chartData?.indicators?.percentageHomeless}
        />
    );
};
